import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import FederalTaxClassificationTypes from './FederalTaxClassificationTypes.json';

export const FederalTaxClassification = ({ inputModel, ...props }) => {
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <SelectInput
        {...props}
        label="Federal Tax Classification"
        validators={{ required: 'Please select one.' }}
        isSearchable
        isClearable
        inputModel={inputModel}
        styles={{
          option: (base) => {
            return {
              ...base,
              cursor: 'pointer',
            };
          },
          control: (base) => {
            return {
              ...base,
              cursor: 'pointer',
            };
          },
        }}
        placeholder="Select One"
        model={inputModel}
        options={FederalTaxClassificationTypes}
      />
    </React.Fragment>
  );
};

FederalTaxClassification.propTypes = {
  inputModel: PropTypes.string.isRequired,
};

FederalTaxClassification.defaultProps = {};
